/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_Source_Download_FailedInputs */



/**
* | output |
* | --- |
* | "The file could not be downloaded from the source. Retry once the connection is working again." |
*
* @param {Embedding_Error_Source_Download_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_source_download_failed = /** @type {((inputs?: Embedding_Error_Source_Download_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_Source_Download_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Datei konnte nicht von der Quelle heruntergeladen werden. Versuchen Sie es erneut, sobald die Verbindung wieder funktioniert.")
	return /** @type {LocalizedString} */ ("The file could not be downloaded from the source. Retry once the connection is working again.")
});